import React from 'react';
import { Input } from 'antd';
const { TextArea } = Input;

const CustomTextArea = ({ ...props }) => {
  return <TextArea {...props} />;
};

export default CustomTextArea;
